<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.custom-group-type.edit.formation.details', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name"
                                                   [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                                  [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="searchable"
                                                   [(ngModel)]="model.data.searchable"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-row [label]="'wbo.custom-group-type.edit.field-set.usage'">
                            <fui-columns>
                                <fui-column>
                                    <fui-tandem-field>
                                        <wbo-checkbox-edit-control [readonly]="fixedType"
                                                                   formControlName="productLineContext"
                                                                   [(ngModel)]="model.data.productLineContext"></wbo-checkbox-edit-control>
                                        <wbo-checkbox-edit-control [readonly]="fixedType"
                                                                   formControlName="inventoryContext"
                                                                   [(ngModel)]="model.data.inventoryContext"></wbo-checkbox-edit-control>
                                    </fui-tandem-field>
                                    <fui-tandem-field>
                                        <wbo-checkbox-edit-control [readonly]="fixedType"
                                                                   formControlName="outletContext"
                                                                   [(ngModel)]="model.data.outletContext"></wbo-checkbox-edit-control>
                                        <wbo-checkbox-edit-control *ngIf="Plugin.LOYALTY | booleanConfig"
                                                                   [readonly]="fixedType"
                                                                   formControlName="membershipTypeContext"
                                                                   [(ngModel)]="model.data.membershipTypeContext"></wbo-checkbox-edit-control>
                                    </fui-tandem-field>
                                </fui-column>
                            </fui-columns>
                        </fui-row>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description"
                                                   [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <ng-container *ngIf="editPage.editMode !== EditMode.ADD">
        <fui-formation-group-template
            *formationGroup="{title: 'wbo.' + model.getResource() + '.edit.formation.custom-groups', formControlNames: 'customObjects'}">
            <wbo-edit-grid [data]="model.data.customObjects" [editable]="true" [removable]="false"
                           [entityPath]="'customObjects'">
                <wbo-edit-link-column field="name" [editMode]="EditMode.VIEW"
                                      [editComponent]="CustomObjectEditPageComponent"></wbo-edit-link-column>
                <wbo-text-column field="description"></wbo-text-column>
                <wbo-edit-grid-add-row [identifierField]="'customObjectTypeId'">
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-new-entity
                            [editComponent]="CustomObjectEditPageComponent"
                            [parentEntity]="model.data"></wbo-edit-grid-add-row-new-entity>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-formation-group-template>
    </ng-container>
    <ng-container>
        <fui-formation-group-template
            *formationGroup="{title: 'wbo.custom-group-type.edit.formation.custom-fields', formControlNames: 'customFields'}">
            <wbo-edit-grid [data]="model.data.customFields" [editable]="true"
                           [removable]="true" [entityPath]="'customFields'">
                <wbo-text-column field="value" [editable]="true"></wbo-text-column>
                <wbo-edit-grid-add-row [identifierField]="'customObjectTypeId'">
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-formation-group-template>
    </ng-container>
</wbo-edit-page>
